module.exports = __webpack_public_path__ + "img/bgpic2.da6c3bc4.png";